import type { Iso2700127701ControlModificacion } from "../../types/control-modificaciones";
import { Iso2700127701ConfirmDialog } from "../shared";

type Props = {
  row: Iso2700127701ControlModificacion | null;
  submitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function Iso2700127701ControlModificacionDeleteModal({
  row,
  submitting,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Iso2700127701ConfirmDialog
      open={row !== null}
      title="Eliminar modificación"
      description={row ? `Se eliminará la modificación registrada en ${row.fecha}.` : ""}
      confirming={submitting}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
